export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';
export const DAILY_RENT_OTA_CONVERSION = 'dailyrent_web_sut375_online_booking_cr';
export const NB_LAYOUT_LISTING = 'newbuilding_layout_listing_inside_jk_desktop';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  NB_HELP_IN_SEARCH,
  RENTER_FORM_EXPERIMENT,
  AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT,
  DAILY_RENT_OTA_CONVERSION,
  NB_LAYOUT_LISTING,
];
